/* eslint-disable */
import React from "react";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import { fetchGraphQL } from "../../../services/api-raindrop";
import Currency from "../../../ui-components/currency/currency.tsx";
import { Size } from "../../../logic/enums.ts";
import RaindropBackButtonPanel from "../../../ui-components/raindrop-back-button-panel/raindrop-back-button-panel.tsx";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import RaindropTextHeading1 from "../../../ui-components/raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import RaindropTextParagraph from "../../../ui-components/raindrop-text-paragraph/raindrop-text-paragraph.tsx";

const CoffeeDonationOption = ({
  donationOption,
  selectedDonationOption = null,
  setSelectedDonationOption = (x) => {
    setSelectedDonationOption;
  },
}) => {
  const onClick = () => {
    setSelectedDonationOption(donationOption);
  };

  let borderClass = "border-4 border-color-dark-background-secondary";
  let hoverClass =
    "md:hover:bg-color-dark-background-tertiary md:hover:scale-95";

  const title = donationOption.title;
  const emoji = donationOption.emoji;
  const subunits = donationOption.subunits;

  const isSelected =
    donationOption.subunits === selectedDonationOption?.subunits;

  if (isSelected) {
    borderClass = "border-4 border-color-raindrop-primary";
  }

  return (
    <div
      onClick={onClick}
      className={`flex flex-col gap-6 w-full items-center p-8 bg-color-dark-background-secondary rounded-lg transition-all ${borderClass} ${hoverClass}`}
    >
      <p className="text-6xl">{emoji}</p>
      <div className="flex flex-col items-center">
        <h1 className="text-xl font-bold">{title}</h1>
        <p className="text-color-dark-text-secondary">
          <Currency
            subunits={subunits}
            isStylised={true}
            isShowingCurrencySymbol={false}
          />
        </p>
      </div>
    </div>
  );
};

const StageIntroduction = ({ onNextStage = () => {} }) => {
  const onClick = () => {
    onNextStage();
  };
  return (
    <div className="flex flex-col items-center justify-center w-full h-full gap-6">
      <RaindropCard>
        <RaindropTextHeading1>Support us with a coffee</RaindropTextHeading1>
        <RaindropTextParagraph>
          Our mission is to make kindness as easy as possible and we want to
          keep building.
        </RaindropTextParagraph>

        <RaindropTextParagraph>
          If you could shout us a coffee, Shnoodle and the team will love you
          forever.
        </RaindropTextParagraph>

        <RaindropTextParagraph>
          We'll even throw in a super secret badge 🤫
        </RaindropTextParagraph>
      </RaindropCard>

      <RaindropButton
        title="Help us out"
        onClick={onClick}
        style={ButtonStyle.Primary}
        isFluid={true}
        size={Size.Large}
      />
    </div>
  );
};

const StageSelectDonation = ({
  donationOptions,
  selectedDonationOption,
  setSelectedDonationOption = (x) => {},
  setSubunits = (x) => {},
  onClick = () => {},
  onPreviousStage = () => {},
}) => {
  return (
    <div className="flex flex-col w-full h-full relative gap-4">
      <div className="flex flex-wrap gap-4 items-center justify-center h-full overflow-y-scroll ">
        {donationOptions.map((d) => (
          <CoffeeDonationOption
            donationOption={d}
            selectedDonationOption={selectedDonationOption}
            setSelectedDonationOption={setSelectedDonationOption}
          />
        ))}
      </div>

      <div className="flex flex-row gap-2">
        <RaindropButton
          title={"Back"}
          isFluid={true}
          onClick={() => {
            setSubunits(null);
            onPreviousStage();
          }}
        />

        <RaindropButton
          title={"Continue"}
          size={Size.Large}
          isFluid={true}
          style={ButtonStyle.Primary}
          onClick={onClick}
          isDisabled={selectedDonationOption == null}
        />
      </div>
    </div>
  );
};

const StageConfirmation = ({
  selectedDonationOption,
  hasActivePaymentMethod = true,
  onNextStage = () => {},
  onPreviousStage = () => {},
}) => {
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const onClick = () => {
    setIsSubmitting(!isSubmitting);

    const subunits = selectedDonationOption.subunits;

    fetchGraphQL(`
            mutation {
                createCoffeeOrder(
                    subunits: ${subunits},
                    subunitsCurrency: "GBP"
                ) {
                    id
                }
            }
        `)
      .then((data) => {
        console.log("🟢 (RD-12344) - ", data);
        onNextStage();
      })
      .catch((error) => {
        console.error("🔴 (RD-12345) - ", error);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="flex flex-col gap-5 pt-12 h-full">
      <div className="flex flex-col h-full gap-4">
        <h1 className="font-bold text-3xl">Is this right? 🐰</h1>
        <p className="text-color-dark-text-secondary">
          You're amazing. Honestly. Thank you.
        </p>
        <p className="text-color-dark-text-secondary">
          You'll recieve a super secret badge for helping us.
        </p>

        <div className="p-6">
          <CoffeeDonationOption donationOption={selectedDonationOption} />
        </div>
      </div>

      {!hasActivePaymentMethod && (
        <RaindropButton
          title={"Set up your card"}
          to={"/raindrop/payment-method-add"}
          isFluid={true}
          size={Size.Large}
          style={ButtonStyle.Primary}
        />
      )}

      {hasActivePaymentMethod && (
        <div className="flex flex-row gap-2">
          <RaindropButton
            title={"Back"}
            isFluid={true}
            size={Size.Large}
            onClick={() => onPreviousStage()}
          />
          <RaindropButton
            title={"Confirm"}
            style={ButtonStyle.Primary}
            isFluid={true}
            size={Size.Large}
            onClick={onClick}
            isLoading={isSubmitting}
          />
        </div>
      )}
    </div>
  );
};

const StageThankYou = () => {
  return (
    <div className="flex flex-col h-full items-center justify-center gap-6 ">
      <i className="fa fa-heart text-5xl text-color-raindrop-primary" />
      <h1 className="font-bold text-4xl">Thank you!</h1>
      <h1 className="text-color-dark-text-secondary w-64">
        We can only keep building thanks to people like you.
      </h1>
    </div>
  );
};

const RaindropBuyCoffee = ({ userCurrent }) => {
  const donationOptions = [
    {
      title: "Buy us a coffee",
      emoji: "☕",
      subunits: 499,
    },
    {
      title: "Buy Shnoodle some carrots",
      emoji: "🥕",
      subunits: 999,
    },
    {
      title: "Buy some seeds",
      emoji: "🌱",
      subunits: 1999,
    },
    {
      title: "We need a new kettle",
      emoji: "🫖",
      subunits: 2999,
    },
  ];

  enum Stage {
    Introduction,
    Selection,
    Confirmation,
    ThankYou,
  }

  const [stage, setStage] = React.useState(Stage.Introduction);

  const [selectedDonationOption, setSelectedDonationOption] =
    React.useState(null);

  const hasActivePaymentMethod = userCurrent.account.paymentMethodActive;

  return (
    <div className="flex flex-col w-full h-full overflow-y-scroll p-4">
      <RaindropBackButtonPanel />
      {stage === Stage.Introduction && (
        <StageIntroduction onNextStage={() => setStage(Stage.Selection)} />
      )}

      {stage === Stage.Selection && (
        <StageSelectDonation
          donationOptions={donationOptions}
          selectedDonationOption={selectedDonationOption}
          setSelectedDonationOption={setSelectedDonationOption}
          onPreviousStage={() => setStage(Stage.Introduction)}
          onClick={() => setStage(Stage.Confirmation)}
        />
      )}

      {stage === Stage.Confirmation && (
        <StageConfirmation
          selectedDonationOption={selectedDonationOption}
          onNextStage={() => {
            setStage(Stage.ThankYou);
          }}
          onPreviousStage={() => setStage(Stage.Selection)}
          hasActivePaymentMethod={hasActivePaymentMethod}
        />
      )}

      {stage === Stage.ThankYou && selectedDonationOption != null && (
        <StageThankYou
          subunits={selectedDonationOption.subunits}
          onPreviousStage={() => setStage(Stage.Selection)}
        />
      )}
    </div>
  );
};

export default RaindropBuyCoffee;
